import type { SnapshotFrom } from 'xstate';
import { availabilityCalendarMachine, isSingleDateEditor } from './availabilityCalendar.machine';

export type AvailabilityCalendarSnapshot = SnapshotFrom<typeof availabilityCalendarMachine>;

export const selectAnchorISO = (snapshot: AvailabilityCalendarSnapshot) =>
  snapshot.context.anchorISO;
export const selectViewMode = (snapshot: AvailabilityCalendarSnapshot) => snapshot.context.viewMode;
export const selectDays = (snapshot: AvailabilityCalendarSnapshot) => snapshot.context.days;
export const selectContracts = (snapshot: AvailabilityCalendarSnapshot) =>
  snapshot.context.contracts;
export const selectContractsError = (snapshot: AvailabilityCalendarSnapshot) =>
  snapshot.context.contractsError;
export const selectRules = (snapshot: AvailabilityCalendarSnapshot) => snapshot.context.rules;
export const selectListings = (snapshot: AvailabilityCalendarSnapshot) => snapshot.context.listings;
export const selectScope = (snapshot: AvailabilityCalendarSnapshot) => snapshot.context.scope;
export const selectSelectedDates = (snapshot: AvailabilityCalendarSnapshot) =>
  snapshot.context.selectedDates;
export const selectEditorDates = (snapshot: AvailabilityCalendarSnapshot) =>
  snapshot.context.editorDates;
export const selectIsSingleDateEditor = (snapshot: AvailabilityCalendarSnapshot) =>
  isSingleDateEditor(snapshot.context);
export const selectTimezone = (snapshot: AvailabilityCalendarSnapshot) => snapshot.context.timezone;
export const selectTodayISO = (snapshot: AvailabilityCalendarSnapshot) => snapshot.context.todayISO;
export const selectError = (snapshot: AvailabilityCalendarSnapshot) => snapshot.context.error;
export const selectConflict = (snapshot: AvailabilityCalendarSnapshot) => snapshot.context.conflict;
export const selectNotice = (snapshot: AvailabilityCalendarSnapshot) => snapshot.context.notice;
export const selectHasAuthoritativeLoad = (snapshot: AvailabilityCalendarSnapshot) =>
  snapshot.context.hasAuthoritativeLoad;
export const selectLoading = (snapshot: AvailabilityCalendarSnapshot) =>
  snapshot.matches('loading');
export const selectBusy = (snapshot: AvailabilityCalendarSnapshot) =>
  !snapshot.matches('idle') && !snapshot.matches('ready');
